import { WordPress } from "../../../../wordpress/wordpress_api";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { CMSState, Link } from "../../../../cms/blocks/types.gen";
import React from "react";
import Lottie from 'react-lottie';



export type ImageTextAttributes = {
  blockName: 'vidda/image-text'
  image_position: 'left' | 'right'
  image: WordPress.MediaResponse
  title: string
  intro: string
  primary_button?: Link
  secondary_button?: Link

  isAnimation: boolean
  animation_data: string

  show_in_page_navigation: boolean
  navigation_title: string
}

export interface ImageTextInterface {
  blockName: 'vidda/image-text'
  attrs: ImageTextAttributes
}

export type ImageTextBlockProps<extra_images> = ImageTextAttributes

export type ImageTextBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export function ImageTextBlock<customBlockData, extra_images>(
  props: ImageTextBlockProps<extra_images>,
  options?: { style: ImageTextBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <section
          id={props.navigation_title}
          className={`block block--image-text${props.image_position == 'right' ? " block--image-right" : " block--image-left"}`}>
          <div className="block__inner b--vc container container--l grid--block">
            <header className="block__header item--2">
              {props.title && <h2 className="block__title typo--l">{props.title}</h2>}
              {props.intro && <p className="block__intro text--styled" dangerouslySetInnerHTML={{ __html: props.intro }}></p>}
            </header>
            <div className="block__visual item--1">
              {props.animation_data && props.isAnimation ?
                <Lottie
                  options={{
                    loop: true,
                    path: props.animation_data,
                  }}
                />
                : 
               props.image ? 
               <img src={props.image.media_details.sizes['medium'].source_url}
               className="block__image"
               /> : 
                null

              }
            </div>
          </div>
        </section>
      )
    })
  }
}


// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/imageTextBlock.mod.tsx